export const REPORT_SCHEMA_VERSION = 2;

export const REPORT_V2_OPTIONS = Object.freeze({
  A: "RESULT",
  B: "PLAYING",
  C: "RAGE_QUIT",
  D: "CONNECTION_ISSUE",
});

export function buildReportV2Request(optionCode, payload = {}) {
  const normalizedOption = String(optionCode || "").trim().toUpperCase();
  const semanticType = REPORT_V2_OPTIONS[normalizedOption];
  if (!semanticType) throw new Error("invalid-v2-report-option");
  return {
    reportType: normalizedOption,
    optionCode: normalizedOption,
    reportSchemaVersion: REPORT_SCHEMA_VERSION,
    semanticType,
    payload: payload || {},
  };
}
